export function openPdfFromBase64(base64Data: string, fileName: string): void {
  const cleaned = (base64Data || '')
    .replace(/^data:application\/pdf;base64,/, '')
    .replace(/^"|"$/g, '')
    .trim();
  if (!cleaned) {
    throw new Error('Document PDF vide');
  }

  const binary = atob(cleaned);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.target = '_blank';
  anchor.rel = 'noopener';
  anchor.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export function extractPdfBase64(raw: unknown): string {
  if (typeof raw === 'string' && raw.trim()) {
    return raw.trim();
  }
  if (raw && typeof raw === 'object') {
    const record = raw as Record<string, unknown>;
    const candidate = record['pdfBase64'] ?? record['data'] ?? record['content'];
    if (typeof candidate === 'string') {
      return candidate.trim();
    }
  }
  return '';
}
